import P30P32Report from './P30P32Report';

const P30Report = () => <P30P32Report reportType="P30" />;

export default P30Report;
